import React, { useEffect, useRef, useState } from "react";
import {
  StyledBoxAddressFormContainer,
  StyledBoxLocation,
  StyledBoxPersonal,
  StyledBoxPersonalInform,
  StyledBoxTabAll,
  StyledBoxTabValue,
  StyledBoxTabValueInform,
  StyledBoxWrapper,
  StyledGridContainer,
  StyledGridLocation,
  StyledInfoCard,
  StyledInfoGrid,
  StyledInfoLabel,
  StyledInfoValue,
  StyledProfileContentBox,
  StyledProfilePhotoContainer,
  StyledTypography,
  StyledTypographyProfile,
  StyledTypographyTab,
  StyledTypographyTabValue,
  StyledTypographyTabValueInform,
  StyledTypographyTabValueUpdate,
  StyledTypographyTabValueUpdateInform,
  StyledTypographyUpdateProfile,
} from "../../pages/profile/style";
import { Box } from "@mui/material";
import theme from "../../theme";
import CustomButton from "../common/button/CustomButton";
import mailIcon from "../../assets/images/email-profile.png";
import { AddressLocation } from "../address-default/AddressLocation";
import EditAddress from "../address-default/EditAddress";
import { useDispatch, useSelector } from "react-redux";
import { capitalizeString, formatToLongDate } from "../../utils/common";
import CallIcon from "../../assets/Icons/CallIcon";
import BirthIcon from "../../assets/Icons/BirthIcon";
import GenderIcon from "../../assets/Icons/GenderIcon";
import { UPLOAD } from "../../actions/AuthActions";
import ProfilePlaceholder from "../common/profile-placeholder/ProfilePlaceholder";

const PersonalInformation = ({ setViewProfile }) => {
  const dispatch = useDispatch();
  const addressList = useSelector((state) => state?.address?.addressList);
  const profileDetails = useSelector((state) => state?.auth?.profileDetails);
  const uploadImageLink = useSelector((state) => state.auth?.uploadSuccess);
  const [profileImage, setProfileImage] = useState("");
  const defaultAddressList = addressList?.filter((val) => val?.is_default);
  const [value, setValue] = useState("all");
  const [addAddress, setAddAddress] = useState(false);
  const [addressId, setAddressId] = useState("");
  const fileInputRef = useRef();
  useEffect(() => {
    if (profileDetails?.profile_image) {
      setProfileImage(profileDetails?.profile_image || "");
    }
  }, [profileDetails?.profile_image]);

  // const handleButtonClick = () => {
  //   fileInputRef.current.click();
  // };
  return (
    <>
      <StyledBoxWrapper>
        <Box>
          <StyledTypographyProfile>Profile</StyledTypographyProfile>
          <StyledTypographyUpdateProfile>
            View and manage your profile information
          </StyledTypographyUpdateProfile>
        </Box>

        {profileDetails?.user_type !== "personal_shopper" && (
          <CustomButton
            padding="14px 22px"
            fontSize={theme.typography.regular.fontSize}
            height="46px"
            btnLabel="Edit Profile"
            btntype={"primary"}
            color={theme.palette.custom.white}
            fontWeight={theme.typography.fontWeight.medium}
            border={theme.borders.defaultButton}
            onClick={() => {
              setViewProfile(true);
            }}
          />
        )}
      </StyledBoxWrapper>
      <StyledBoxPersonal margin="true">
        <StyledBoxTabValue>
          <StyledTypographyTabValue>
            Personal Information
          </StyledTypographyTabValue>
          <StyledTypographyTabValueUpdate>
            Your basic profile information
          </StyledTypographyTabValueUpdate>
        </StyledBoxTabValue>

        <StyledProfileContentBox>
          {/* Avatar */}
          <StyledProfilePhotoContainer>
            {profileImage ? (
              <img src={profileImage} alt="ProfileIcon" loading="lazy" className="profile-image"
                style={{ width: 110, height: 110, borderRadius: "50%", objectFit: "cover", border: "3px solid #0B65B5" }}
              />
            ) : (
              <ProfilePlaceholder size={110} showBorder />
            )}
            {/* <StyledInfoName>{profileDetails?.name}</StyledInfoName> */}
            <input type="file" id="fileInput" style={{ display: "none" }} ref={fileInputRef}
              onChange={(e) => { const file = e.target.files[0]; dispatch({ type: UPLOAD, payload: file }); setProfileImage(uploadImageLink); }}
              accept="image/*"
            />
          </StyledProfilePhotoContainer>

          {/* Info Fields */}
          <StyledInfoGrid>
            <StyledInfoCard>
              <StyledInfoLabel>Full Name</StyledInfoLabel>
              <StyledInfoValue>
                <span className="info-text">
                  {profileDetails?.name || <StyledTypography>Not provided</StyledTypography>}
                </span>
              </StyledInfoValue>
            </StyledInfoCard>
            <StyledInfoCard>
              <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <img src={mailIcon} alt="mail" style={{ width: 16, height: 16 }} />
                <StyledInfoLabel>Email Address</StyledInfoLabel>
              </Box>
              <StyledInfoValue sx={{ paddingLeft: "22px" }}>
                <span className="info-text">
                  {profileDetails?.email || <StyledTypography>Not provided</StyledTypography>}
                </span>
              </StyledInfoValue>
            </StyledInfoCard>
            <StyledInfoCard>
              <StyledInfoLabel>Mobile Number</StyledInfoLabel>
              <StyledInfoValue>
                <CallIcon color={profileDetails?.phone_number ? theme.palette.custom.primary : theme.palette.custom.notProvide} />
                <span className="info-text">
                  {profileDetails?.phone_number || <StyledTypography>Not provided</StyledTypography>}
                </span>
              </StyledInfoValue>
            </StyledInfoCard>
            <StyledInfoCard>
              <StyledInfoLabel>Alternate Contact</StyledInfoLabel>
              <StyledInfoValue>
                <CallIcon color={profileDetails?.alternative_phone_number ? theme.palette.custom.primary : theme.palette.custom.notProvide} />
                <span className="info-text">
                  {profileDetails?.alternative_phone_number || <StyledTypography>Not provided</StyledTypography>}
                </span>
              </StyledInfoValue>
            </StyledInfoCard>
            <StyledInfoCard>
              <StyledInfoLabel>Date of Birth</StyledInfoLabel>
              <StyledInfoValue>
                <BirthIcon color={profileDetails?.date_of_birth ? theme.palette.custom.primary : theme.palette.custom.notProvide} />
                <span className="info-text">
                  {profileDetails?.date_of_birth ? formatToLongDate(profileDetails?.date_of_birth) : <StyledTypography>Not provided</StyledTypography>}
                </span>
              </StyledInfoValue>
            </StyledInfoCard>
            <StyledInfoCard>
              <StyledInfoLabel>Gender</StyledInfoLabel>
              <StyledInfoValue>
                <GenderIcon color={profileDetails?.gender ? theme.palette.custom.primary : theme.palette.custom.notProvide} />
                <span className="info-text">
                  {capitalizeString(profileDetails?.gender) || <StyledTypography>Not provided</StyledTypography>}
                </span>
              </StyledInfoValue>
            </StyledInfoCard>
          </StyledInfoGrid>
        </StyledProfileContentBox>
      </StyledBoxPersonal>

      <StyledBoxPersonalInform>
        <StyledBoxTabValueInform>
          <Box>
            <StyledTypographyTabValueInform>
              Address Information
            </StyledTypographyTabValueInform>
            <StyledTypographyTabValueUpdateInform>
              Your shipping addresses
            </StyledTypographyTabValueUpdateInform>
          </Box>

          {profileDetails?.user_type !== "personal_shopper" && (
            <CustomButton
              padding="14px 22px"
              fontSize={theme.typography.regular.fontSize}
              height="46px"
              btnLabel="Add New Address"
              btntype={"white"}
              color={theme.palette.custom.lockerValueColor}
              fontWeight={theme.typography.fontWeight.medium}
              border={theme.borders.defaultButton}
              onClick={() => {
                setAddressId("");
                setAddAddress(true);
              }}
            />
          )}
        </StyledBoxTabValueInform>
        <StyledBoxAddressFormContainer>

        {/* Rishabh : Edit address form moved above address lists */}
        {addAddress && (
            <EditAddress
              setAddAddress={setAddAddress}
              addressId={addressId}
              addressList={addressList}
            />
          )}
          <StyledBoxTabAll>
            <StyledTypographyTab
              value={value === "all"}
              onClick={() => setValue("all")}
            >
              All Addresses
            </StyledTypographyTab>
            <StyledTypographyTab
              value={value === "default"}
              onClick={() => setValue("default")}
            >
              Default Address
            </StyledTypographyTab>
          </StyledBoxTabAll>
          
          {value === "all" ? (
            <StyledGridContainer container spacing={2}>
              {addressList?.map((value) => (
                <StyledGridLocation
                  key={value.id}
                  size={{ md: 6, sm: 12, xs: 12 }}
                >
                  <StyledBoxLocation>
                    <AddressLocation
                      data={value}
                      setAddressId={setAddressId}
                      setAddAddress={setAddAddress}
                    />
                  </StyledBoxLocation>
                </StyledGridLocation>
              ))}
            </StyledGridContainer>
          ) : (
            <StyledGridContainer container spacing={2}>
              {defaultAddressList?.map((value) => (
                <StyledGridLocation key={value.id} size={{ md: 6, sm: 12, xs: 12 }}>
                  <Box>
                    <AddressLocation
                      data={value}
                      setAddressId={setAddressId}
                      setAddAddress={setAddAddress}
                    />
                  </Box>
                </StyledGridLocation>
              ))}
            </StyledGridContainer>
          )}
        </StyledBoxAddressFormContainer>
      </StyledBoxPersonalInform>
    </>
  );
};

export default PersonalInformation;
